import "./app.shared-Daoj6J3H.js";

var wishlist_button_default = (() => {
    if (customElements.get("wishlist-button")) return;
    customElements.define("wishlist-button", class WishlistButton extends HTMLElement {
        get epi() {
            return this.dataset.variantId;
        }
        connectedCallback() {
            this.button = this.querySelector("button");
            if (!this.button || !window.MBF?.swym) return;
            if (window.MBF.settings?.wishlistEnabled === false) {
                this.hidden = true;
                return;
            }
            this.empi = this.dataset.productId;
            this.du = this.dataset.productUrl;
            this.dt = this.dataset.productTitle;
            this.iu = this.dataset.productImage;
            this.pr = this.dataset.productPrice;
            this.strings = window.MBF.strings?.wishlist || {};
            this.button.addEventListener("click", this);
            this.syncMembership();
        }
        syncMembership() {
            if (!window.MBF?.swym) return;
            if (window.MBF.settings?.wishlistEnabled === false) return;
            window.MBF.swym.ready().then(() => window.MBF.swym.hydrate()).then(() => this.reflectState(window.MBF.swym.isInWishlist(this.empi, this.epi))).catch(() => {});
        }
        disconnectedCallback() {
            this.button?.removeEventListener("click", this);
        }
        handleEvent(event) {
            if (event.type !== "click") return;
            event.preventDefault();
            event.stopPropagation();
            const pressed = this.button.getAttribute("aria-pressed") === "true";
            const payload = {
                empi: this.empi,
                epi: this.epi,
                du: this.du,
                dt: this.dt,
                iu: this.iu,
                pr: this.pr
            };
            (pressed ? window.MBF.swym.removeFromWishlist(payload) : window.MBF.swym.addToWishlist(payload)).then(ok => {
                if (ok) this.reflectState(!pressed); else this.showErrorToast();
            });
        }
        showErrorToast() {
            const message = this.strings.error;
            if (!message) return;
            document.dispatchEvent(new CustomEvent("toast:show", {
                detail: {
                    message: message
                }
            }));
        }
        reflectState(active) {
            if (!this.button) return;
            this.button.setAttribute("aria-pressed", String(active));
            this.button.setAttribute("aria-label", (active ? this.strings.added : this.strings.add) || "");
            this.button.classList.toggle("is-wishlisted", active);
        }
    });
})();